import './PaymentTotal.css';
import { formatDollarAmount } from '../../util/EfupUtility';

export const PaymentTotal = props => {
    return (
            <div className="cb-row">
            <div className="cb-col-lg">
              <h2 className="subTitle">
                Total:
                <span data-testid="payment-total" className="subTitleBold">{formatDollarAmount(props.total)}</span>
                <div className="tool-tip">!
                    <span data-testid="payment-total-tooltip" className="tooltiptext">Updating the filters and sorting may cause this amount to change. 
                        Results display a maximum of {props.maxResults} records. The total excludes payments in a closed status unless closed status is selected on the status filter.</span>
                </div>
              </h2>
            </div>
          </div>
    )
}